// Editing the in-app keyboard's text. It only ever grows or shrinks at the
// end: there is no caret to move, which is what keeps a phone's own keyboard
// from opening over it.

import { letterUnits } from "./check.ts";

/** Long enough for any sentence a step asks for; a runaway key repeat stops here. */
export const MAX_TYPED = 120;

export const typeText = (text: string, add: string): string =>
	text.length + add.length > MAX_TYPED ? text : text + add;

/** Removes the last letter, ու as a whole: it was typed with one key. */
export function backspace(text: string): string {
	const units = letterUnits(text);
	units.pop();
	return units.join("");
}
